<template>
    <div>
        <table class="vehicle-table">
            <thead>
                <tr>
                    <th>VRef</th>
                    <th>Start time</th>
                    <th>Line</th>
                    <th>Description</th>
                    <th>Journey guid</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <JourneyWorkingRow v-for="journey in dataStore.workingjourneys" :key="journey.guid" :journey="journey" />
            </tbody>
        </table>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import JourneyWorkingRow from './JourneyWorkingRow.vue';

const dataStore = inject('datastore');

</script>

<style>

.vehicle-table {
  width: 100%; /* Make the table take up 100% of the container width */
  table-layout: auto; /* Fix the layout of the table */
  border-collapse: collapse;
}

.vehicle-table thead {
  background-color: #007bff; /* Set the background color of the header row */
  color: white; /* Optional: change the text color to contrast */
}

.vehicle-table th, .vehicle-table td {
  border: 1px solid #ccc;
  padding: 0px 10px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
}

.vehicle-table th:nth-child(4), /* Target the third column for the extra space */
.vehicle-table td:nth-child(4) {
  width: 100%; /* Let this column take all the remaining space */
}

</style>